<template>
  <section
    class="hero is-bold app-navbar animated"
    :class="{ slideInDown: show, slideOutDown: !show }"
  >
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left">
          <a
            class="nav-item is-hidden-tablet"
            @click="toggleSidebar(!sidebar.opened)"
          >
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
        <div class="nav-center">
          <div class="nav-item hero-brand" @click="reloadPage()">
            <div class="is-hidden-mobile">
              <span class="vue">内容标注平台</span>
              <span class="vue branch-show" v-show="dev.isShow">
                tagging：{{ dev.tagging }}
              </span>
            </div>
          </div>
        </div>
        <div class="nav-right is-flex">
          <span class="nav-item" v-show="!!user && user.id">
            {{ user.name + '（ID:' + user.id + '）' }}
          </span>
          <router-link v-if="!isLogin" to="/login" class="nav-item"
            >登录
          </router-link>
          <a v-else @click="logout" class="nav-item">退出</a>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import * as MutationTypes from 'src/store/mutation-types';
import ewxLoginSDK from '@qtt/ewx-login-sdk';
import QuRequest from '../../core/QuRequest';

const quRequest = new QuRequest();

const branchMap = quRequest.getBranch();

// console.log(branchMap)

export default {
  components: {},

  props: {
    show: Boolean,
  },

  data() {
    return {
      dev: {
        isShow: false,
        qk: '',
        qp: '',
        audit: '',
        author: '',
      },
    };
  },

  computed: mapGetters({
    sidebar: 'sidebar',
    isLogin: 'isLogin',
    user: 'getUser',
  }),

  methods: {
    ...mapActions(['toggleSidebar']),
    logout() {
      let { $store, $router } = this;
      ewxLoginSDK.logout({ isPerm: true }).then(res => {
        $store.commit(MutationTypes.SET_TOKEN, '');
        $store.commit(MutationTypes.LOGIN_USER, {
          id: '',
          name: '',
        });
      });
    },
    reloadPage() {
      window.location && window.location.reload(true);
    },
  },
  mounted() {
    let { $store, dev } = this;
    if (CODE_EVN === 'development') {
      dev.isShow = true;
      dev.tagging = branchMap['tagging'] || '';
      // dev.qp = branchMap['qupost'] || ''
      // dev.audit = branchMap['audit'] || ''
      // dev.comment = branchMap['comment'] || ''
      // dev.online_content = branchMap['online_content'] || ''
      // dev.author = branchMap['author'] || ''
    }
    if (this.isLogin) {
      quRequest.send(quRequest.Apis.perm.member.getMember).then(({ data }) => {
        if (data && data.member && data.member.id) {
          this.id = data.member.id;
          this.name = data.member.name;
          $store.commit(MutationTypes.LOGIN_USER, {
            id: data.member.id,
            name: data.member.name,
          });
          this.$http
            .send(this.$http.Apis.bzxt.user.login, {
              user_name: data.member.name,
            })
            .then(res => {})
            .catch(err => {
              this.$message.error(
                `记录用户登录信息信息失败：${err.message || '未知错误'}`,
              );
            });
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import '../../../node_modules/bulma/sass/utilities/variables';

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.hero-brand {
  position: relative;
  .vue {
    margin-left: 10px;
    color: #36ac70;
  }
  .admin {
    color: #28374b;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?1f8206f6